import { STORE_ID, TYPES } from "./types";
import store from "../../index";

function dispatch(data) {
    data = { ...data, storeId: STORE_ID }
    store.dispatch(data);
}

export function setPermitions(value) {
    dispatch({
        type: TYPES.SET_PERMITIONS,
        value
    })
}

export function setNiveisHierarquicos(value) {
    dispatch({
        type: TYPES.SET_NIVEIS_HIERARQUICOS,
        value
    })
}

export function item(value) {
    dispatch({
        type: TYPES.HIERARQUIA,
        value
    });
}

export function copy(value) {
    dispatch({
        type: TYPES.HIERARQUIA_COPY,
        value
    });
}

export function setInvalid(field) {
    dispatch({
        type: TYPES.INVALID_HIERARQUIA,
        field
    });
}

export function getItems(value) {
    dispatch({
        type: TYPES.HIERARQUIAS,
        value
    });
}

export function getCanaisVenda(value) {
    dispatch({
        type: TYPES.SET_CANAIS_VENDA,
        value
    });
}

export function cleanInvalid(field) {
    dispatch({
        type: TYPES.CLEAN_INVALID_HIERARQUIA,
        field
    });
}

export function cleanRegister() {
    dispatch({
        type: TYPES.CLEAN_REGISTER
    })
}

export function setActiveTab(value) {
    dispatch({
        type: TYPES.SET_ACTIVE_TAB,
        value
    })
}

export function setSeeRegister(value) {
    dispatch({
        type: TYPES.SET_SEE,
        value
    })
}
